import { fetchCmsSeoAll } from "./cmsPublicApi";

let seoByPath = null;
let loadPromise = null;

export const loadCmsSeoCache = async () => {
  if (seoByPath) {
    return seoByPath;
  }
  if (!loadPromise) {
    loadPromise = fetchCmsSeoAll().then((response) => {
      const map = {};
      if (response?.success && Array.isArray(response.data)) {
        response.data.forEach((row) => {
          if (row?.path) {
            map[row.path] = row;
          }
        });
      }
      seoByPath = map;
      return map;
    });
  }
  return loadPromise;
};

export const getCmsSeoForPath = (pathname) => {
  if (!seoByPath || !pathname) {
    return null;
  }
  return seoByPath[pathname] || null;
};

const defaultSetMeta = (title, description, keywords = null) => {
  const updateMetaTag = (name, content) => {
    let metaTag = document.querySelector(`meta[name="${name}"]`);
    if (metaTag) {
      metaTag.setAttribute("content", content);
    } else {
      metaTag = document.createElement("meta");
      metaTag.name = name;
      metaTag.content = content;
      document.head.appendChild(metaTag);
    }
  };

  updateMetaTag("title", title);
  document.title = title;
  updateMetaTag("description", description);
  updateMetaTag("og:title", title);
  updateMetaTag("og:description", description);
  updateMetaTag("twitter:title", title);
  updateMetaTag("twitter:description", description);

  const keywordsTag = document.querySelector('meta[name="keywords"]');
  if (keywords) {
    updateMetaTag("keywords", keywords);
  } else if (keywordsTag) {
    keywordsTag.remove();
  }
};

export const applySeoRow = (row, setMetaFn = defaultSetMeta) => {
  if (!row) {
    return false;
  }

  setMetaFn(row.title || document.title, row.description || "", row.keywords || null);

  if (row.robots) {
    let tag = document.querySelector('meta[name="robots"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.name = "robots";
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", row.robots);
  }

  if (row.og_image) {
    const updateOg = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        metaTag.name = name;
        metaTag.content = content;
        document.head.appendChild(metaTag);
      }
    };
    updateOg("og:image", row.og_image);
    updateOg("twitter:image", row.og_image);
  }

  return true;
};

export const applyBlogPostFallbackMeta = (post) => {
  if (!post) {
    return false;
  }

  return applyCmsContentFallbackMeta({
    title: post.title,
    description: post.seo?.description || post.description || post.excerpt || "",
    seo: post.seo || null,
    hero_image: post.hero_image,
  });
};

export const applyCmsContentFallbackMeta = ({
  title,
  description = "",
  seo = null,
  hero_image = null,
}) => {
  const resolvedTitle =
    seo?.title || (title ? `${title} | EquityProtect` : document.title);

  return applySeoRow({
    title: resolvedTitle,
    description: seo?.description || description || "",
    keywords: seo?.keywords || null,
    og_image: seo?.og_image || hero_image || null,
  });
};

export const applyCmsSeoMeta = (pathname, setMetaFn) => {
  const row = getCmsSeoForPath(pathname);
  if (!row) {
    return false;
  }

  return applySeoRow(row, setMetaFn);
};

export const resetCmsSeoCache = () => {
  seoByPath = null;
  loadPromise = null;
};
